<template>
  <div class="agreement-page pcStyle">
    <Header />
    <div class="page-content">
      <div class="content-title">{{ i18n.independentMarketing.agreement.title }}</div>
      <div class="agreement-content">
        <iframe :src="url" frameborder="0" width="100%" height="100%" title="Agreement"></iframe>
      </div>
      <div class="footer-box">
        <button class="common-btn" @click="next">{{ i18n.independentMarketing.agreement.nextBtn }}</button>
      </div>
    </div>
  </div>
</template>
<script>
  import Header from '../components/Header.vue';
  import { getAgreementApi } from '@/api/independentMarketing.js';
  import { getCloudLang } from '@/utils/fns';
  export default {
    components: {
      Header,
    },
    data() {
      return {
        url: '',
        loading: false,
      };
    },
    created() {
      // 获取协议内容
      this.getAgreement();
    },
    mounted() {
      const iframe = document.querySelector('iframe');
      iframe.onload = () => {
        this.$hideLoading();
      };
    },
    methods: {
      getAgreement() {
        this.$showLoading();
        getAgreementApi({
          appId: 'JXSGLXT000',
          language: getCloudLang(),
          typeCodes: [0],
          countryCode: '',
        })
          .then(res => {
            const { data, code, message } = res;
            if (code !== 200) {
              this.$hideLoading();
              this.$showToast(message || this.i18n.independentMarketing.agreement.getAgreementFailed);
              return;
            }
            if (!data?.length) {
              this.$hideLoading();
              this.$showToast(this.i18n.independentMarketing.agreement.getAgreementFailed);
              return;
            }
            this.url = data[0].protocolUrl;
          })
          .catch(err => {
            this.$hideLoading();
            this.$showToast(this.i18n.independentMarketing.agreement.getAgreementFailed);
          });
      },
      next() {
        this.$router.push('/independent-marketing/apply-form');
      },
    },
  };
</script>
<style lang="less" scoped>
.agreement-page.pcStyle {
  height: 100%;
  box-sizing: border-box;
  .page-content {
    .content-title {
      font-size: 24px;
      font-weight: bold;
      color: #303030;
      margin-top: 60px;
      margin-bottom: 30px;
      text-align: center;
    }
    .agreement-content {
      font-size: 16px;
      color: #555;
      line-height: 24px;
      height: 60%;
      overflow-y: hidden;
      padding: 10px 0;
    }
    .footer-box {
      text-align: center;
      padding-top: 40px;
      .common-btn {
        min-width: 248px;
        height: 48px;
        background: #e0121b;
        border-radius: 6px;
        border: 1px solid #e0121b;
        color: #fff;
        font-size: 20px;
        cursor: pointer;
        &:active {
          opacity: 0.8;
        }
      }
    }
  }
}
</style>